import { render, staticRenderFns } from "./booking-row-skeleton.vue?vue&type=template&id=30ec5a60&scoped=true&"
import script from "./booking-row-skeleton.vue?vue&type=script&lang=js&"
export * from "./booking-row-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./booking-row-skeleton.vue?vue&type=style&index=0&id=30ec5a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ec5a60",
  null
  
)

export default component.exports